import React from 'react';

import { WpContainer, WpContainerBody } from '../../container';
import WpDivider from '../WpDivider';

const DividerDocs = () => {
  const Basic = () => {
    return (
      <WpContainer>
        <WpContainerBody>
          some text here
          <WpDivider />
          some more text here that is seperate
        </WpContainerBody>
      </WpContainer>
    );
  };

  const WithText = () => {
    return (
      <WpContainer>
        <WpContainerBody>
          some text here
          <WpDivider text="divider text here" />
          some more text here that is seperate
        </WpContainerBody>
      </WpContainer>
    );
  };

  const WithTextAndPaddings = () => {
    const paddings = [0, 4, 8, 12, 16, 20, 24, 28, 32] as const;
    return (
      <>
        {paddings.map(padding => (
          <WpContainer className="mb-2">
            <WpContainerBody>
              some text here
              <WpDivider text={`${padding} padding`} padding={padding} />
              some more text here that is seperate
            </WpContainerBody>
          </WpContainer>
        ))}
      </>
    );
  };

  return (
    <div>
      <h5 className="mb-3">Basic Line Divider</h5>
      <Basic />
      <h5 className="mt-3 mb-3">With Text</h5>
      <WithText />
      <h5 className="mt-3 mb-3">With Padding</h5>
      <WithTextAndPaddings />
    </div>
  );
};

export default DividerDocs;
